// AI assisted development
export const environment = {
  debug: false,
  envCode: 'STAGE',
  isProd: false,
  version: '1.2.0',

  overrideUsernameAndPassword: false,
  username: '',
  password: '',

  adminPortalUrl: 'https://adminstage.shopperkit.com/',
  adminPortalForgottenPasswordPath: 'forgotyourpassword',

  BaseApiUrl: 'https://apicommandcenter-stage.shopperkit.com/api/v1/',   
  BaseApiCoreUrl: 'https://apistage.shopperkit.com/api/v1/',

  BaseMessagingServiceUri: 'https://messagingstage.shopperkit.com/api/v1/',
  BaseMessagingServiceUriSignalr: 'https://messaging-stage.shopperkit.com/api/v1/',
  MessagingWebSocketUri: 'wss://messagingstage.shopperkit.com/api/v1/websocket/',
  MessagingSignalRUri: "https://messaging-stage.shopperkit.com/api/v1/signalr/",

  idleTimeout: 24 * 60 * 60, // seconds
  idleTimeoutActionCountdown: 30, // seconds
  idleAuthCheckThreshold: 10, // seconds

  authTokenValidityDuration: 30, // minutes

  testingToggles: {
    filterDates: false,
  },

  featureToggles: {
    examplesArea: false,
    inventoryInspectorDashboard: false
  },

  /** Pendo workflow kill switch. false skips agent load and SDK calls even if pendoApiKey is set. */
  pendoEnabled: true,
  /** Pendo Web SDK API key for SKit.CommandCenter. Empty = Pendo disabled. Source: vault / PM. */
  pendoApiKey: 'f62eae33-ee0f-413d-6274-cf0e04c2ed08',
};
